module.exports = __webpack_public_path__ + "img/ylands_comp_create_top_600.1c3a22c1.webp";